module.exports = __webpack_public_path__ + "static/img/6.f743996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/6.png
// module id = vIWk
// module chunks = 1